import { Component, ViewChild, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { ITALY_BOUNDS } from 'src/core/config/map-config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-address-search',
  templateUrl: './address-search.component.html',
  styleUrls: ['./address-search.component.scss'],
})
export class AddressSearchComponent implements AfterViewInit {
  @ViewChild('searchTextField', { static: false }) searchTextField: any;
  @Output() placeSelected = new EventEmitter<any>();
  @Output() placeChanged = new EventEmitter<any>();
  @Input() label: string;
  @Input() disabled: boolean = false;
  environment = environment;
  autocomplete: any;  
  placeholder = 'Type or pick an address';

  get inputLabel() {
    return this.label ? this.label : '';
  }



  ngAfterViewInit() {
    this._initAutoComplete();
  }

  private _initAutoComplete() {
    const options: google.maps.places.AutocompleteOptions = {
      bounds: ITALY_BOUNDS,
      types: ['address'],
      strictBounds: true,
      componentRestrictions: { country: 'it' },
      fields: ['geometry', 'name', 'formatted_address', 'address_components'],
    };
    this.autocomplete = new google.maps.places.Autocomplete(
      this.searchTextField?.nativeElement,
      options,
    );
    const self = this;

    this.autocomplete.addListener('place_changed', () => {
      const p = self.autocomplete.getPlace();
      if (p && p.formatted_address) {
        self.placeSelected.emit({ point: p, isValid: true });
      } else {
        self.placeSelected.emit({ point: p, isValid: false });
      }
      const inputAddress = this.searchTextField?.nativeElement;
      if (inputAddress) {
        setTimeout(() => {
          inputAddress.click();
        }, 1000);
      }
    });
  }
  
  onChangeContent(event) {
    if (event && event.inputType) {
      if (event.inputType == 'insertFromPaste' || event.inputType == 'deleteContentBackward' || event.inputType == 'deleteContentForward' || event.inputType == 'deleteByCut') {
        this.placeChanged.emit();
      }
    }
  }
}
